<div class="component-title">
  <div [class]="size()" class="component-title__content" data-cy="reports:report:name">
    <ng-content />
    {{ name() }}
  </div>
  @if (description()) {
    <rt-icon
      [rtTooltip]="description()"
      [rtTooltipMaxWidth]="420"
      [size]="size() === 'small' ? 'small-x' : 'small'"
      class="gridster-item-content component-title__icon"
      name="help-outline"
    />
  }
</div>
